<!-- 商品总账流水列表 -->
<template>
    <div class='page_content' v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.4)">
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="formList.tmscoldChainList.length > 0" :searchList="formList.tmscoldChainList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" id="tableData" :data="returnData.list" :height="tableHeight" border style="width: 100%" stripe ref="stockTable" :header-cell-style="{ background: '#fff' }">
                <el-table-column header-align='center' label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="waybillId" label="运单号" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="orderCode" label="订单号" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveName" label="客户名称" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveAddress" label="地址" min-width="200px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="carPlate" label="车牌号" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="orderDate" label="制单时间" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="startTran" label="起运时间" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="finishTime" label="签收时间" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productName" label="产品名称" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productSpec" label="规格" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="stbusiness" label="生产厂商" min-width="200px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productPlace" label="产地" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="batch" label="批号" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="proddate" label="生产日期" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="expidate" label="失效日期" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="orderNum" label="数量" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="userName" label="委托经办人" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sendName" label="发货人" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sendPhone" label="发货人电话" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="shipperAddress" label="发货人地址" min-width="200px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveName" label="收货人" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receivePhone" label="收货人电话" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveAddress" label="收货人地址" min-width="200px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="consignee" label="提货人" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="internalName" label="内勤姓名" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="signImg" label="签收图片" min-width="200px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.signImg">
                            <el-image v-for="(item, index) in scope.row.signImg.split(',')" :key="index" style="width: 50px; height: 50px" :src="$store.getters.getConfig.TMSimgUrl + '/' + item" fit="contain"
                                      :preview-src-list="[$store.getters.getConfig.TMSimgUrl + '/' + item]"></el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="trackingNum" label="物流单号" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="shipperFreight" label="物流费用" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="carrierName" label="承运商" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="wlcarPlate" label="车牌" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="driverName" label="司机" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="trackingImg" label="物流运输轨迹" min-width="200px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.trackingImg">
                            <el-image v-for="(item, index) in scope.row.trackingImg.split(',')" :key="index" style="width: 50px; height: 50px" :src="$store.getters.getConfig.TMSimgUrl + '/' + item" fit="contain"
                                      :preview-src-list="[$store.getters.getConfig.TMSimgUrl + '/' + item]"></el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="tempImg" label="温湿度" min-width="200px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.tempImg">
                            <div v-for="(item, index) in scope.row.tempImg.split(',')" :key="index" style="width: 50px; height: 50px;display: flex;align-items: center;flex-wrap: wrap;">
                                <el-image v-if="item.indexOf('pdf') == -1" style="width: 50px; height: 50px" :src="$store.getters.getConfig.TMSimgUrl + '/' + item" fit="contain"
                                          :preview-src-list="[$store.getters.getConfig.tempImg + '/' + item]"></el-image>
                                <el-image @click="tiao(item)" v-else style="width: 50px; height: 50px" :src="require('@/assets/Pdf.png')" fit="contain"></el-image>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="wlcarPlate" label="签收类型" min-width="110px">
                    <template slot-scope="scope">
                        {{ getQSType(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="incubatorDevice" label="保温箱设备号" min-width="120px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="startTemp" label="起运温度" min-width="100px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endTemp" label="送达温度" min-width="100px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="roadTemp" label="在途温度" min-width="100px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="roadMax" label="在途最高温度" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="roadMin" label="在途最低温度" min-width="110px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="startTran" label="起运时间" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endTran" label="到货时间" min-width="150px"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ddrName" label="调度人" min-width="150px"></el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"
                          :pageSize="[30, 100, 200, 300, 400, 500, 1000, 2000, 5000, 50000, 1000000]"></v-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="1000px" top="1rem">
            <div id="container"></div>
        </el-dialog>
        <el-dialog title="温湿度" :visible.sync="tempFlag" width="1000px" top="1rem">
            <iframe :src="tempImg" frameborder="0" style="width: 980px;height: 700px;"></iframe>
        </el-dialog>
        <el-dialog title="物流轨迹" v-if="logisticsFlag" :visible.sync="logisticsFlag" width="700px" top="1rem">
            <div style="padding: 20px;">
                <p style="padding-bottom:10px;font-size:18px;font-weight:700;">物流单号：{{ logisticsObj.LogisticCode }}</p>
                <div style="height:200px;overflow: auto;border:1px solid #b1b1b1;margin-bottom:10px;padding:5px;">
                    <div style="padding-bottom:10px;" v-for="(item,index) in logisticsData" :key="index">
                        <p style="color:#009688;padding-bottom:5px;">{{ ActionClick(Number(item.Action)) }}</p>
                        <p>{{ item.Location == null ? '' : item.Location }}</p>
                        <p style="color:#8d8d8d">{{ item.AcceptStation }}</p>
                        <p style="color:#8d8d8d">{{ item.AcceptTime }}</p>
                    </div>
                </div>
                <iframe id="myFrame" :src='`${logisticsObj.RouteMapUrl}&change=${returnData.list[selectedDataIndex].trackingNumber}&nocopy=true`' width="640px" height="400px" frameborder="0"></iframe>
            </div>
        </el-dialog>
        <el-dialog title="运单状态" v-if="waybillTypeShow" :visible.sync="waybillTypeShow" width="700px" top="1rem">
            <el-form inline ref="form" label-width="80px">
                <el-form-item label="运单号">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.slwbr_ydh"></el-input>
                </el-form-item>
                <el-form-item label="运输方式">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.transmode"></el-input>
                </el-form-item>
                <el-form-item label="发货方">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.slwbr_fhdw"></el-input>
                </el-form-item>
                <el-form-item label="收货方">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.slwbr_shdw"></el-input>
                </el-form-item>
                <el-form-item label="温度记录仪编号" v-if="waybillType==1">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.wdjlybh"></el-input>
                </el-form-item>
                <el-form-item label="温度时间">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.sswdsj"></el-input>
                </el-form-item>
                <el-form-item label="温度信息">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.sswdtxt"></el-input>
                </el-form-item>
                <el-form-item label="物流状态">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.wlstat"></el-input>
                </el-form-item>
                <el-form-item label="物流位置">
                    <el-input class="yd_input" readonly v-model="waybillTypeObj.wlpos"></el-input>
                </el-form-item>
            </el-form>
            <div style="height:200px;overflow: auto;border:1px solid #b1b1b1;margin-bottom:10px;padding:5px;">
                <div style="padding-bottom:10px;" v-for="(item,index) in waybillTypeData" :key="index">
                    <p style="color:#009688;padding-bottom:5px;font-size: 16px;font-weight: 700;"><span>{{ item.phase }}</span><span style="margin-left: 10px;">{{ item.dt }}</span></p>
                    <p style="color:#8d8d8d">{{ item.desc }}</p>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="运单温度" v-if="temperatureShow" :visible.sync="temperatureShow" width="1200px" top="1rem">
            <div id="tempLineChart" style="width: 100%; height: 400px;"></div>
            <div style="display: flex;align-items: center;justify-content: center;">
                <el-pagination background layout="prev, pager, next" :total="temperatureData.length" :current-page="currentPage" :page-size="20" @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog title="查询运单文件" v-if="fileShow" :visible.sync="fileShow" width="1050px" top="1rem">
            <el-form inline ref="form" label-width="80px" size="small">
                <el-form-item label="运单号">
                    <el-select style="width: 250px;" v-model="fileType" placeholder="请选择">
                        <el-option label="现场签收照⽚" :value="3"></el-option>
                        <el-option label="全程温度数据⽂件" :value="4"></el-option>
                        <el-option label="返单扫描存档照⽚" :value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="extractPic()">提取图片</el-button>
                </el-form-item>
            </el-form>
            <ul class="ul_img">
                <li v-for="(item,index) in fileList" :key="index" class="li_img" :class="{'li_img1':item.url.indexOf('data:application/pdf;base64')!=-1}">
                    <p style="text-align: center;font-size: 16px; padding: 5px 0;">{{ item.name }}</p>
                    <cusImage v-if="item.url.indexOf('data:application/pdf;base64')==-1" style="width: 300px; height: 300px;" :src="item.url" :preview-src-list="fileList.map(item=>item.url)" :fit="'contain'"></cusImage>
                    <iframe v-else :src="item.url" frameborder="0" style="width: 100%; height: 800px"></iframe>
                </li>
            </ul>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'     // 引入axios
import AMapLoader from '@amap/amap-jsapi-loader'; //引入
import * as echarts from 'echarts';
import { EleResize } from '@/common/esresize';
import formList from './tms.js'
export default {
    name: "tmscoldChainList",
    data() {
        //这里存放数据
        return {
            loading: false,
            tableHeight: 0,
            buttonList: [],
            getRequestData: {
                orderCode:"",//订单号
                receiveName: "", //客户名称
                productName: "",//产品名称
                start: "",//开始时间
                end: "",//结束时间
                page: 1,
                rows: 30,
            },
            activeName: "0",
            returnData: {
                total: 0, // 总条数
                list: [],
            },
            selectedDataIndex: 0,
            dialogVisible: false,
            waybillId: "",
            carWindow: "",//信息展示框
            map: null, //初始化 map 对象
            formList: formList,
            excelData: [],
            fieldList: [
                {
                    label: "运单号",
                    prop: "waybillId",
                    type: "string",
                },
                {
                    label: "订单号",
                    prop: "orderCode",
                    type: "string",
                },
                {
                    label: "客户名称",
                    prop: "receiveName",
                    type: "string",
                },
                {
                    label: "地址",
                    prop: "receiveAddress",
                    type: "string",
                },
                {
                    label: "车牌号",
                    prop: "carPlate",
                    type: "string",
                },
                {
                    label: "起运时间",
                    prop: "createDate",
                    type: "string",
                },
                {
                    label: "签收时间",
                    prop: "finishTime",
                    type: "string",
                },
                {
                    label: "产品名称",
                    prop: "productName",
                    type: "string",
                },
                {
                    label: "规格",
                    prop: "productSpec",
                    type: "string",
                },
                {
                    label: "生产厂商",
                    prop: "stbusiness",
                    type: "string",
                },
                {
                    label: "产地",
                    prop: "productPlace",
                    type: "string",
                },
                {
                    label: "批号",
                    prop: "batch",
                    type: "string",
                },
                {
                    label: "生产日期",
                    prop: "proddate",
                    type: "string",
                },
                {
                    label: "失效日期",
                    prop: "expidate",
                    type: "string",
                },
                {
                    label: "数量",
                    prop: "orderNum",
                    type: "string",
                },
                {
                    label: "委托经办人",
                    prop: "userName",
                    type: "string",
                },
                {
                    label: "签收图片",
                    prop: "signImg",
                    type: "string",
                },
                {
                    label: "物流单号",
                    prop: "trackingNum",
                    type: "string",
                },
                {
                    label: "物流费用",
                    prop: "shipperFreight",
                    type: "string",
                },
                {
                    label: "承运商",
                    prop: "carrierName",
                    type: "string",
                },
                {
                    label: "车牌",
                    prop: "wlcarPlate",
                    type: "string",
                },
                {
                    label: "司机",
                    prop: "driverName",
                    type: "string",
                },
                {
                    label: "发货人",
                    prop: "sendName",
                    type: "string",
                },
                {
                    label: "发货人电话",
                    prop: "sendPhone",
                    type: "string",
                },
                {
                    label: "发货人地址",
                    prop: "shipperAddress",
                    type: "string",
                },
                {
                    label: "收货人",
                    prop: "receiveName",
                    type: "string",
                },
                {
                    label: "收货人电话",
                    prop: "receivePhone",
                    type: "string",
                },
                {
                    label: "收货人地址",
                    prop: "receiveAddress",
                    type: "string",
                },
                {
                    label: "提货人",
                    prop: "consignee",
                    type: "string",
                },
                {
                    label: "内勤姓名",
                    prop: "internalName",
                    type: "string",
                },
                {
                    label: "物流运输轨迹",
                    prop: "trackingImg",
                    type: "string",
                },
                {
                    label: "签收类型",
                    prop: "wlcarPlate",
                    type: "select",
                },
                {
                    label: "保温箱设备号",
                    prop: "incubatorDevice",
                    type: "string",
                },
                {
                    label: "起运温度",
                    prop: "startTemp",
                    type: "string",
                },
                {
                    label: "送达温度",
                    prop: "endTemp",
                    type: "string",
                },
                {
                    label: "在途温度",
                    prop: "roadTemp",
                    type: "string",
                },
                {
                    label: "在途最高温度",
                    prop: "roadMax",
                    type: "string",
                },
                {
                    label: "在途最低温度",
                    prop: "roadMin",
                    type: "string",
                },
                {
                    label: "起运时间",
                    prop: "startTran",
                    type: "string",
                },
                {
                    label: "到货时间",
                    prop: "endTran",
                    type: "string",
                },
            ],
            tempFlag: false,
            tempImg: "",
            logisticsShow: false,
            logisticsFlag: false,
            areaObj: {},
            logisticsObj: {},
            logisticsData: [],
            //-------------运单温度------------------
            temperatureShow: false,
            temperatureData: [],
            currentPage: 1,
            transmode: 0,
            //-------------运单状态------------------
            waybillTypeShow: false,
            waybillType: 0,
            waybillTypeObj: {
                slwbr_ydh: "",//运单号
                transmode: "",//配送方式
                slwbr_fhdw: "",//发货方
                slwbr_shdw: "",//收货方
                wdjlybh: "",//温度记录仪编号
                sswdsj: "",//温度时间
                sswdtxt: "",//温度信息
                wlstat: "",//物流状态
                wlpos: "",//物流位置
            },
            waybillTypeData: [],
            //----------------运单文件------------------
            fileShow: false,
            fileObj: {},
            fileList: [],
            fileType: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
        getAuthToken() {
            const userInfo = this.$store.getters.getUserInfo;
            return userInfo !== false ? sessionStorage.getItem('token') : null;
        },
        getPageInfo() {
            this.getButtonList()
            this.getDataList()
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.see()
                    break;
                case 1:
                    this.f_track()
                    break;
                case 2:
                    this.see1()
                    break;
                case 3:
                    this.f_temperature()
                    break;
                case 4:
                    this.f_waybillType()
                    break;
                case 5:
                    this.f_file()
                    break;
                case 6:
                    this.exportChange()
                    break;
                default:
                    break;
            }
        },
        see1() {
            const info = this.getSelectedRow();
            if (!info) return;
            const phone = info.sendPhone || info.warePhone;
            const params = `
                 {
                    'ShipperCode':'${info.trackingNumber || ""}',
                    'LogisticCode':'${info.trackingNum || ""}',
                    'CustomerName':'${phone ? String(phone).slice(-4) : ''}',
                    'IsReturnRouteMap':'1',
                    "Sender":{
                       "ProvinceName":"${this.areaObj.ProvinceName || ""}",
                       "CityName":"${this.areaObj.CityName || ""}",
                       "ExpAreaName":"${this.areaObj.ExpAreaName || ""}",
                       "Address":"${this.areaObj.Address || ""}"
                    },
                    "Receiver":{
                    "ProvinceName":"${info.receiveProvince || ""}",
                       "CityName":"${info.receiveCity || ""}",
                       "ExpAreaName":"${info.receiveCounty || ""}",
                       "Address":"${info.receiveAddress || ""}"
                    }
                 }
                 `;
            const token = this.getAuthToken();
            axios({
                url: this.$store.getters.getConfig.TMSrequestUrl + `/carriercase/queryKdn`,
                method: 'POST',
                headers: {
                    token: token,
                    'Content-Type': 'application/json;charset=utf8',
                },
                data: JSON.stringify({
                    requestData: params,
                    dataType: "2",
                    requestType: "8003",
                }),
            }).then(res => {
                if (res.data.status == 200) {
                    this.logisticsObj = JSON.parse(res.data.result)
                    if (this.logisticsObj.Success) {
                        if (this.logisticsObj.State != 0) {
                            this.logisticsData = [...this.logisticsObj.Traces].reverse()
                            this.logisticsFlag = true
                        } else {
                            this.$alert('提示', "暂无物流轨迹", {
                                confirmButtonText: '关闭',
                                callback: action => { }
                            });
                        }
                    } else {
                        this.$alert('提示', this.logisticsObj.Reason, {
                            confirmButtonText: '关闭',
                            callback: action => { }
                        });
                    }
                }
            })
        },
        ActionClick(val) {
            switch (val) {
                case 1:
                    return '已揽收'
                    break;
                case 2:
                    return '在途中'
                    break;
                case 201:
                    return '到达派件城市'
                    break;
                case 204:
                    return '到达转运中心'
                    break;
                case 205:
                    return '到达派件网点'
                    break;
                case 206:
                    return '寄件网点发件'
                    break;
                case 202:
                    return '派件中'
                    break;
                case 211:
                    return '已放入快递柜或驿站'
                    break;
                case 3:
                    return '已签收'
                    break;
                case 301:
                    return '正常签收'
                    break;
                case 302:
                    return '派件异常后最终签收'
                    break;
                case 304:
                    return '代收签收'
                    break;
                case 311:
                    return '快递柜或驿站签收'
                    break;
                case 4:
                    return '问题件'
                    break;
                case 401:
                    return '发货无信息'
                    break;
                case 402:
                    return '超时未签收'
                    break;
                case 403:
                    return '超时未更新'
                    break;
                case 404:
                    return '拒收(退件)'
                    break;
                case 405:
                    return '派件异常'
                    break;
                case 406:
                    return '退货签收'
                    break;
                case 407:
                    return '退货未签收'
                    break;
                case 412:
                    return '快递柜或驿站超时未取'
                    break;
                case 413:
                    return '单号已拦截'
                    break;
                case 414:
                    return '破损'
                    break;
                case 415:
                    return '客户取消发货'
                    break;
                case 416:
                    return '无法联系'
                    break;
                case 417:
                    return '配送延迟'
                    break;
                case 418:
                    return '快件取出'
                    break;
                case 419:
                    return '重新派送'
                    break;
                case 420:
                    return '收货地址不详细'
                    break;
                case 421:
                    return '收件人电话错误'
                    break;
                case 422:
                    return '错分件'
                    break;
                case 423:
                    return '超区件'
                    break;
                case 5:
                    return '转寄'
                    break;
                case 6:
                    return '清关'
                    break;
                case 601:
                    return '待清关'
                    break;
                case 602:
                    return '清关中'
                    break;
                case 603:
                    return '已清关'
                    break;
                case 604:
                    return '清关异常'
                    break;
                case 10:
                    return '待揽件'
                    break;
                default:
                    break;
            }
        },
        tiao(url) {
            this.tempImg = url && /^https?:\/\//.test(url)
                ? url
                : `${this.$store.getters.getConfig.TMSimgUrl}/${url}`
            this.tempFlag = true
        },
        exportChange() {
            this.excelData = this.returnData.list;
            this.export2Excel();
        },
        //表格数据写入excel
        export2Excel() {
            const listBeiFen = JSON.parse(JSON.stringify(this.excelData))
            const nameList = [];
            const fieldList = [];
            this.fieldList.forEach((item) => {
                nameList.push(item.label);
                fieldList.push(item.prop);
            });
            listBeiFen.forEach(item => {
                item['wlcarPlate'] = this.getQSType(item)
            })
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                const data = this.formatJson(fieldList, listBeiFen);
                export_json_to_excel(nameList, data, 'TMS运输记录');
            });
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        openSearch() { },
        getSelectedRow() {
            if (this.returnData.list.length === 0) {
                this.$message.error("暂无数据")
                return null
            }
            const row = this.returnData.list[this.selectedDataIndex]
            if (!row) {
                this.$message.error("请选择数据")
                return null
            }
            return row
        },
        getQSType(d) {
            if (d.signType == 0) {
                return '配送'
            } else if (d.signType == 1) {
                return '自提'
            } else if (d.signType == 2) {
                return '物流'
            }
        },
        see() {
            const row = this.getSelectedRow();
            if (!row) return;
            this.dialogVisible = true
            this.waybillId = row.waybillId
            this.$nextTick(() => {
                this.initMap(0)
            })
        },
        changeTime() { },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        getDataList() {
            const token = this.getAuthToken();
            const params = {
                ...this.getRequestData,
                ormId: sessionStorage.getItem('ormId'),
                ormName: sessionStorage.getItem('ormName'),
                start: this.getRequestData.start ? this.getRequestData.start + ' 00:00:00' : '',
                end: this.getRequestData.end ? this.getRequestData.end + ' 23:59:59' : '',
            }
            this.loading = true
            axios({
                url: this.$store.getters.getConfig.TMSrequestUrl + '/waybill/erpTranData',
                method: 'POST',
                headers: {
                    token: token
                },
                data: params
            }).then(res => {
                this.loading = false
                if (res.data.status == 200) {
                    this.returnData.list = res.data.rows
                    this.returnData.total = res.data.total
                    this.tableHeight = this.$common.getTableHeight() + 40;
                }
            }).catch(err => {
                this.loading = false
            })
        },
        initMap(val) {
            AMapLoader.load({
                key: "8b5f269722b34ed8c6d1db1920891ae0", //此处填入我们注册账号后获取的Key
                version: "2.0", //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [''], //需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
                this.map = new AMap.Map("container", { //设置地图容器id
                    viewMode: "3D", //是否为3D地图模式
                    zoom: 5, //初始化地图级别
                    center: [105.602725, 37.076636], //初始化地图中心点位置
                });
                // 3.创建跟速度信息展示框
                this.carWindow = new AMap.InfoWindow({
                    offset: new AMap.Pixel(6, -25),
                    content: ""
                });
                if (val == 1) {
                    this.trackQuery()
                } else {
                    this.mapData()
                }
            }).catch(e => {
                console.log(e);
            })
        },
        mapData() {
            var userInfo = this.$store.getters.getUserInfo
            var token = null
            if (userInfo != false) {
                token = sessionStorage.getItem('token')
            }
            axios({
                // 请求地址
                url: this.$store.getters.getConfig.TMSrequestUrl + `/driverPosition/queryCarGps?waybillId=${this.waybillId}`,
                method: 'get',
                headers: {
                    token: token
                },
            }).then(res => {
                console.log(res);
                this.renderTrace(res.data.rows)
            })
        },
        renderTrace(d) {
            this.map.clearMap();

            // 2.创建小汽车marker
            this.carMarker = new AMap.Marker({
                map: this.map,
                position: [d[0].longitude, d[0].latitude],
                icon: "http://webapi.amap.com/images/car.png",
                offset: new AMap.Pixel(-26, -13),
                autoRotation: true
            });
            // 4.生成车辆回放轨迹
            var pathPolyline = this.initializePaths(d);
            // alert(pathPolyline.getPath());
            // 5.车辆随轨迹移动
            // this.carMarker.moveTo(pathPolyline.getPath(), 1000, function (k) {
            //     return k
            // }, false);
            // // 7.打开速度框
            this.carWindow.open(this.map, this.carWindow.getPosition());
            // 8.地图自适应缩放
            this.map.setFitView();
        },
        initializePaths(paths) {
            var line;
            var pathLngLatArray = new Array();
            if (paths) {
                for (var i = 0; i < paths.length; i++) {
                    pathLngLatArray.push(new AMap.LngLat(paths[i].longitude, paths[i].latitude));
                }
                line = new AMap.Polyline({
                    map: this.map,
                    path: pathLngLatArray,
                    strokeColor: "#28F", //线颜色
                    showDir: true,
                    strokeOpacity: 0.8,
                    strokeWeight: 6,
                    strokeStyle: 'solid'
                });
                line.setMap(this.map);
            }
            return line;
        },
        // 获取运单状态
        f_waybillType() {
            const dataInfo = this.getSelectedRow();
            if (!dataInfo) return;
            if (!dataInfo.trackingNum) {
                return this.$message.error("暂无运单状态信息")
            }
            this.loading = true
            axios({
                url: this.$store.getters.getConfig.TMSrequestUrl + `/waybill/getSlWaybillStatus/${dataInfo.trackingNum}`,
                method: 'GET',
                headers: {},
            }).then(res => {
                this.loading = false
                if (res.data.status == 200) {
                    const dataObj = res.data.result.data
                    this.waybillTypeObj = {
                        ...this.waybillTypeObj,
                        slwbr_ydh: dataObj.slwbr_ydh,
                        transmode: dataObj.additional.transmode == 1 ? '冷藏⻋运输' : dataObj.additional.transmode == 2 ? '保温箱运输' : '',
                        slwbr_fhdw: dataObj.datainfo.slwbr_fhdw,
                        slwbr_shdw: dataObj.datainfo.slwbr_shdw,
                        wdjlybh: dataObj.datainfo.wdjlybh,
                        sswdsj: dataObj.datainfo.sswdsj,
                        sswdtxt: dataObj.datainfo.sswdtxt,
                        wlstat: dataObj.datainfo.wlstat,
                        wlpos: dataObj.datainfo.wlpos,
                    }
                    this.waybillType = dataObj.additional.transmode
                    this.waybillTypeData = dataObj.datainfo.ydlsinfo2j
                    this.waybillTypeShow = true
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取运单温度
        f_temperature() {
            const dataInfo = this.getSelectedRow();
            if (!dataInfo) return;
            if (!dataInfo.trackingNum) {
                return this.$message.error("暂无运单温度信息")
            }
            this.loading = true
            this.temperatureData = []
            this.currentPage = 1
            axios({
                url: this.$store.getters.getConfig.TMSrequestUrl + `/waybill/getSlWaybillTemp/${dataInfo.trackingNum}`,
                method: 'GET',
                headers: {},
            }).then(res => {
                this.loading = false
                if (res.data.status == 200) {
                    this.temperatureShow = true
                    const dataObj = res.data.result.data;
                    this.transmode = dataObj.additional.transmode
                    const step = 5;
                    for (let i = 0; i < dataObj.datarows.length; i += step) {
                        const element = dataObj.datarows[i];
                        this.temperatureData.push(
                            this.transmode == 1
                                ? { t1: element.t1, t2: element.t2, t3: element.t3, dt: element.dt }
                                : { t1: element.t1, t2: element.t2, dt: element.dt }
                        )
                    }
                    if (this.temperatureData.length > 0) this.handleCurrentChange(1)
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleCurrentChange(val) {
            this.currentPage = val
            const start = (this.currentPage - 1) * 20;
            const end = Math.min(start + 20, this.temperatureData.length);
            const arr1 = this.temperatureData.slice(start, end);
            this.$nextTick(() => {
                this.drawTemperatureChart(arr1)
            })
        },
        drawTemperatureChart(arrData) {
            const temperatureList1 = []
            const temperatureList2 = []
            const temperatureList3 = []
            const dateArr = []
            arrData.forEach(e => {
                temperatureList1.push(e.t1)
                temperatureList2.push(e.t2)
                if (this.transmode == 1) temperatureList3.push(e.t3)
                dateArr.push(e.dt)
            })
            const chartDom = document.getElementById('tempLineChart');
            const myChart = echarts.init(chartDom);
            const isColdChain = this.transmode == 1
            const series = isColdChain
                ? [
                    { name: '探头1', type: 'line', smooth: 0.5, itemStyle: { normal: { label: { show: true } } }, lineStyle: { width: 5, type: 'solid' }, data: temperatureList1 },
                    { name: '探头2', type: 'line', smooth: 0.5, itemStyle: { normal: { label: { show: true } } }, lineStyle: { width: 5, type: 'solid' }, data: temperatureList2 },
                    { name: '探头3', type: 'line', smooth: 0.5, itemStyle: { normal: { label: { show: true } } }, lineStyle: { width: 5, type: 'solid' }, data: temperatureList3 },
                ]
                : [
                    { name: '记录仪1', type: 'line', smooth: 0.5, itemStyle: { normal: { label: { show: true } } }, lineStyle: { width: 5, type: 'solid' }, data: temperatureList1 },
                    { name: '记录仪2', type: 'line', smooth: 0.5, itemStyle: { normal: { label: { show: true } } }, lineStyle: { width: 5, type: 'solid' }, data: temperatureList2 },
                ]
            const option = {
                title: { text: isColdChain ? '运单温度统计(冷藏⻋)' : '运单温度统计(保温箱)', x: 'center' },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: function (data) {
                        return data.map(item => `${item.seriesName}: ${item.data}`).join('<br/>')
                    }
                },
                legend: { data: isColdChain ? ['探头1', '探头2', '探头3'] : ['记录仪1', '记录仪2'], y: 'top', x: 'right' },
                grid: { left: '5%', right: '4%', bottom: '3%', containLabel: true },
                toolbox: { show: false, feature: {} },
                xAxis: [{
                    show: true,
                    type: 'category',
                    boundaryGap: false,
                    data: dateArr,
                    axisTick: { show: true, inside: true, length: 2, lineStyle: { width: 2, type: 'solid' } },
                    axisLabel: { show: true, lineStyle: { width: '5' }, rotate: 45 }
                }],
                yAxis: [{ type: 'value' }],
                series,
            };
            myChart.setOption(option);
            EleResize.on(chartDom, () => {
                myChart && myChart.resize();
            });
        },
        f_file() {
            const dataInfo = this.getSelectedRow();
            if (!dataInfo) return;
            this.fileList = []
            this.fileType = ""
            this.fileShow = true
        },
        extractPic() {
            const dataInfo = this.getSelectedRow();
            if (!dataInfo) return;
            if (!this.fileType) {
                return this.$message.error("请选择文件类型")
            }
            const params = JSON.stringify({
                type: this.fileType,
                billno: dataInfo.trackingNum || dataInfo.waybillId,
            });
            this.loading = true
            axios({
                url: this.$store.getters.getConfig.TMSrequestUrl + `/waybill/getSlWaybillFile`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf8',
                },
                data: params
            }).then(res => {
                this.loading = false
                if (res.data.status == 200) {
                    this.fileList = []
                    var dataObj = res.data.result.data.datainfo
                    if (this.fileType == 3) {
                        dataObj.qsckzp.forEach(item => {
                            this.fileList.push({
                                name: item.filename,
                                url: `data:image/jpeg;base64,${item.filecontent}`
                            })
                        })
                        this.fileList.push(
                            {
                                name: dataObj.qsydzp.filename,
                                url: `data:image/jpeg;base64,${dataObj.qsydzp.filecontent}`
                            }
                        )
                    } else if (this.fileType == 4) {
                        this.fileList.push(
                            {
                                name: dataObj.qcwdsj.filename,
                                url: `data:application/pdf;base64,${dataObj.qcwdsj.filecontent}`
                            }
                        )
                    } else if (this.fileType == 5) {
                        dataObj.khckdfd.forEach(item => {
                            this.fileList.push({
                                name: item.filename,
                                url: `data:image/jpeg;base64,${item.filecontent}`
                            })
                        })
                        this.fileList.push(
                            {
                                name: dataObj.khllfd.filename,
                                url: `data:image/jpeg;base64,${dataObj.khllfd.filecontent}`
                            }
                        )
                        this.fileList.push(
                            {
                                name: dataObj.slydfd.filename,
                                url: `data:image/jpeg;base64,${dataObj.slydfd.filecontent}`
                            }
                        )
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(e => {
                this.loading = false
            })
        },
        f_track() {
            const dataInfo = this.getSelectedRow();
            if (!dataInfo) return;
            if (!dataInfo.trackingNum) {
                return this.$message.error("暂无轨迹信息")
            }
            this.dialogVisible = true
            this.$nextTick(() => {
                this.initMap(1)
            })
        },
        trackQuery() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            axios({
                // 请求地址
                url: this.$store.getters.getConfig.TMSrequestUrl + `/waybill/getSlWaybillTemp/${dataInfo.trackingNum}`,
                method: 'GET',
                headers: {
                },
            }).then(res => {
                if (res.data.status == 200) {
                    var data = []
                    res.data.result.data.datarows.forEach(item => {
                        if (item.lng && item.lat) {
                            data.push({
                                longitude: item.lng,
                                latitude: item.lat,
                            })
                        }
                    })
                    this.renderTrace(data)
                }
            })
        },

    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.logisticsShow = window.global_config.logisticsShow ? true : false
        this.areaObj = window.global_config.areaObj
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { window.addEventListener('resize', () => { this.tableHeight = this.$common.getTableHeight() }) },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { window.removeEventListener("resize", () => { this.tableHeight = this.$common.getTableHeight() }) }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
    overflow-y: auto;
}

.dis {
    display: flex;
    flex-wrap: wrap !important;
}

#container {
    width: 980px;
    height: 700px;
}

::v-deep .amap-logo {
    display: none;
    opacity: 0 !important;
}

::v-deep .amap-copyright {
    opacity: 0;
}

::v-deep .info {
    position: relative;
    margin: 0;
    top: 0;
    right: 0;
    min-width: 0;
}
.yd_input {
    width: 230px;
}
.ul_img {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
}
.li_img {
    width: 300px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
}
.li_img1{
    width: 100%;
    height: 100%;
}
</style>
